import { toast } from 'sonner';

/** Build the `Error` thrown when `listActivityLogs` returns a non-OK response. */
export function catalogListActivityLogsFailureError(
  apiMessage: string | undefined,
  fallbackMessage: string
): Error {
  return new Error(apiMessage ?? fallbackMessage);
}

export function toastCatalogLogsLoadError(err: Error): void {
  toast.error(err.message);
}
